import * as yup from "yup";

export const passwordConfirmationSchema = yup.object().shape({
    password: yup.string().required("A senha é obrigatória"),
});
